<!--<div class="spinner">
</div>-->


<div *ngIf="visible">
   <div class="spinner-div"><div id="spinner" class="spinner"></div></div>
</div>
